export enum EColor {
  /** Зелёный **/
  Green = 'green',
  /** Красный **/
  Red = 'red',
}
export enum ETrend {
  /** Уменьшение **/
  Decrease = 'decrease',
  /** Увеличение **/
  Increase = 'increase',
  /** Без изменения **/
  NoChange = 'noChange',
}

export enum EValuationTabs {
  PriceDynamic = '0',
  SellStatus = '1',
}

export interface IPriceDiff {
  /** Цвет стрелки **/
  color: EColor;
  /** Изменение цены. Пример: 200 000 ₽ **/
  priceDiff: string;
  /** Направление стрелки **/
  trend: ETrend;
}

export interface IPromoText {
  /** Сам emoji **/
  emoji: string;
  /** Ссылка на картинку emoji **/
  emojiUrl: string;
  /** Текст для пользователя. Пример: Отличный момент для покупки! Цены в этом ЖК упали более чем на 5%  **/
  text: string;
}

export interface IPrices {
  /** Значение цены. Пример: 8,7 млн ₽ **/
  price: string;
  /** Данные по изменению цены **/
  priceDiff?: IPriceDiff | null;
}

export interface ISoldData {
  /** Сколько квартир осталось, строка. Пример: Осталось 260 квартир **/
  leftValue: string;
  /** Квартир в этом ЖК продано, процент. **/
  soldPercent: number;
  /** Квартир в этом ЖК продано, строка. Пример: 70% квартир распродано **/
  soldValue: string;
}

export enum EChartType {
  /** Столбчатый график **/
  Bar = 'bar',
  /** Линейный график **/
  Line = 'line',
}

export interface IMonthSale {
  /** Массив продаж по комнатностям в формате '1-комн. — 12 кв.' **/
  roomStats: string[];
}

export interface IBarChart {
  /** Тип графика **/
  chartType: EChartType;
  /** Массив с датами вида 2020-04-26 для точек графика **/
  datesLabels: string[];
  /** Массив со значениями для синей линии графика **/
  firstLineValues: number[];
  /** Шаг шкалы oY **/
  labelStep: number;
  /** Массив с объектами для тултипа **/
  labels: IMonthSale[];
  /** Максимальное значение по oY **/
  maxChartValue: number;
  /** Минимальное значение по oY **/
  minChartValue: number;
  /** Массив со значениями для второй линии графика **/
  secondLineValues: number[];
}

export interface ISoldPercentData {
  /** Сколько квартир осталось, строка. Пример: Осталось 260 квартир **/
  leftValue: string;
  /** Квартир в этом ЖК продано, процент. **/
  soldPercent: number;
  /** Квартир в этом ЖК продано, строка. Пример: 70% квартир распродано **/
  soldValue: string;
}

export interface ISalesDynamics {
  /** График динамики продаж квартир по месяцам **/
  chart: IBarChart;
  /** Данные по распроданности в процентах **/
  soldPercentData?: ISoldPercentData | null;
}

export enum ERoomType {
  /** Все комнатности **/
  All = 'all',
  /** Четырехкомнатная квартира **/
  FourRoom = 'fourRoom',
  /** Однокомнатная квартира **/
  OneRoom = 'oneRoom',
  /** Студия **/
  Studio = 'studio',
  /** Трехкомнатная квартира **/
  ThreeRoom = 'threeRoom',
  /** Двухкомнатная квартира **/
  TwoRoom = 'twoRoom',
}

export interface ILineChart {
  /** Тип графика **/
  chartType: EChartType;
  /** Массив с датами вида 2020-04-26 для точек графика **/
  datesLabels: string[];
  /** Массив со значениями для синей линии графика **/
  firstLineValues: number[];
  /** Шаг шкалы oY **/
  labelStep: number;
  /** Максимальное значение по oY **/
  maxChartValue: number;
  /** Минимальное значение по oY **/
  minChartValue: number;
  /** Массив со значениями для второй линии графика **/
  secondLineValues: number[];
}

export interface ILineChartForBuilders {
  /** График динамики изменения средней стоимости квартир **/
  chart: ILineChart;
  /** Комнатность графика **/
  roomType: ERoomType;
}

export interface IPriceDynamics {
  /** График динамики изменения средней стоимости квартир **/
  charts: ILineChartForBuilders[];
}

export interface IRealtyValuation {
  /** Средние цена за квартиру **/
  avgPrices: IPrices;
  /** Средняя цена кв. метр **/
  avgPricesSqm: IPrices;
  /** Дата последнего обновления **/
  lastUpdateDate: string;
  /** Данные для графиков по средней стоимости квартир **/
  priceDynamics: IPriceDynamics;
  /** Промотекст с эмоджи **/
  promoText?: IPromoText | null;
  /** Данные для блока «Распродано квартир в этом ЖК» **/
  salesDynamics?: ISalesDynamics | null;
}
